import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
// import { useTranslation } from '@pascal/pascal-core';
import { betStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';

import { marketsStore } from '../../../../store/marketsStore';

const Button = observer(({ type, betTypeData = null, onSetMarketData }) => {
  const { selectedMarket, replayActiveHILoSection, activeButton } = marketsStore;
  const { repliedBetData } = betStore;
  const { activeFreeBet } = freeBetStore;

  const buttonValue = useMemo(() => {
    if (!betTypeData) return null;

    return {
      percent: `${betTypeData.percent}%`,
      odd: `x${betTypeData.odd}`,
      marketType: betTypeData.marketType,
      hiOrLo: betTypeData.hiOrLo,
    };
  }, [betTypeData]);

  return (
    <div
      className={`m-g-h-item ${
        (!betTypeData && !replayActiveHILoSection) ||
        (repliedBetData && !replayActiveHILoSection) ||
        activeFreeBet.minOdd > betTypeData?.odd ||
        activeButton
          ? 'disabled'
          : ''
      } ${
        (replayActiveHILoSection === selectedMarket.hiOrLo && repliedBetData) ||
        (buttonValue && buttonValue.hiOrLo === selectedMarket.hiOrLo && !repliedBetData)
          ? 'active'
          : ''
      }`}
      onClick={() => onSetMarketData(betTypeData)}
    >
      <p className='m-g-h-item-p-percent'>{buttonValue && buttonValue.percent}</p>
      <div className={`m-g-h-item-p-img ${type}`} />
      <p className='m-g-h-item-coef'>{buttonValue && buttonValue.odd}</p>
    </div>
  );
});

export default Button;
